import Map from './dom';
export default Map;
